import Axios from 'axios';
import { clearToken, getToken } from '@/services/BackofficeAuthService';
const kidSchoolApi = Axios.create({
    baseURL: process.env.VUE_APP_KIDSCHOOL_API_URL,
    timeout: 15000,
});
kidSchoolApi.interceptors.request.use(async (config) => {
    config.headers = { ...config.headers, Authorization: `Bearer ${await getToken()}` };
    return config;
});
kidSchoolApi.interceptors.response.use((response) => response, async (error) => {
    const config = error.config;
    if (error.response?.status !== 401 || config.retried) {
        throw error;
    }
    clearToken();
    config.retried = true;
    return kidSchoolApi.request(config);
});
export default kidSchoolApi;
